import React from "react";
export const handleSubmitService = async (formData) => {
  try {
    const response = await fetch("https://uni-app-backend.vercel.app/api/create_contact", {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
      },
      body: JSON.stringify(formData),
    });
    const result = await response.json();
    return result;
  } catch (error) {
    return error;
  }
};
